export default [
  {
    name: "Grievance Cases",
    icon: "receipt_long",
    to: "/grievances/list",
    enabled: true,
  },
  {
    name: "Assigned Grievances",
    icon: "receipt_long",
    to: "/grievances/assigned",
    enabled: true,
  },
];
